export const Logo = ({ className = '' }) => {
  return (
    <div
      className={`group inline-flex flex-col items-start gap-1 cursor-pointer ${className}`}
      data-testid="nav-logo"
    >
      <img
        src="/logo-lxra.png"
        alt="LXRA Studios"
        className="lxra-logo-img h-6 sm:h-7 w-auto object-contain object-left flex-none will-change-transform"
      />
      <span
        data-testid="nav-logo-tagline"
        className="text-[9px] tracking-[0.22em] text-[hsl(var(--lxra-muted))] uppercase pl-0.5 transition-colors duration-300 group-hover:text-[hsl(var(--lxra-gold))]"
      >
        Capture a Higher Purpose
      </span>
    </div>
  );
};
